import apiClient from './api';

export const authService = {
    async login(username, password) {
        try {
            const response = await apiClient.post('/auth/login', { username, password });
            return response.data;
        } catch (error) {
            console.error('Login failed:', error);
            throw error;
        }
    },

    async validateToken(token) {
        try {
            const response = await apiClient.post('/auth/validate-token', { token });
            return response.data;
        } catch (error) {
            console.error('Token validation failed:', error);
            throw error;
        }
    },

    async logout() {
        try {
            await apiClient.post('/auth/logout');
        } catch (error) {
            console.error('Logout failed:', error);
        }
    }
};

export default authService;